import React from 'react';
import {useForm, FormProvider} from 'react-hook-form';
import {Row} from 'react-bootstrap';
import {getLanguage, t} from 'react-switch-lang';
import InputText from '../../../../components/FormFields/InputText';
import './FindingsFilter.scss';
import {Col} from 'reactstrap';
import SelectList from '../../../../components/select/SelectList';
import {RISK_LEVEL} from '../../../revisions/const';

const FindingsFilter = ({submit}) => {
  const lang = getLanguage();
  const methods = useForm({});
  const {handleSubmit, watch} = methods;

  return (
    <>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(submit)}>
          <Row className="main-container pt-5 m-0 pb-5">
            <Col>
              <div style={{display: 'flex', gap: '20px', flexWrap: 'wrap'}}>
                <div style={{minWidth: '200px', maxWidth: '200px'}}>
                  <InputText
                    type="text"
                    name="searchInput"
                    placeholder={t('revisions.placeholder.findingName')}
                  />
                </div>
                <div style={{maxWidth: '200px', minWidth: '200px'}}>
                <SelectList
                  name="riskLevel"
                  className="select filterSelect"
                  placeholder={t('revisions.placeholder.riskLevel')}
                  options={
                    getLanguage() === 'eng'
                      ? [
                        {
                          label: RISK_LEVEL.LOW.en,
                          value: RISK_LEVEL.LOW.value,
                        },
                        {
                          label: RISK_LEVEL.MEDIUM.en,
                          value: RISK_LEVEL.MEDIUM.value,
                        },
                        {
                          label: RISK_LEVEL.HIGH.en,
                          value: RISK_LEVEL.HIGH.value,
                        },
                        {
                          label: RISK_LEVEL.VERY_HIGH.en,
                          value: RISK_LEVEL.VERY_HIGH.value,
                        }
                      ]
                      : [
                        {
                          label: RISK_LEVEL.LOW.mne,
                          value: RISK_LEVEL.LOW.value,
                        },
                        {
                          label: RISK_LEVEL.MEDIUM.mne,
                          value: RISK_LEVEL.MEDIUM.value,
                        },
                        {
                          label: RISK_LEVEL.HIGH.mne,
                          value: RISK_LEVEL.HIGH.value,
                        },
                        {
                          label: RISK_LEVEL.VERY_HIGH.mne,
                          value: RISK_LEVEL.VERY_HIGH.value,
                        }
                      ]
                  }
                  isClearable
                />
                </div>
              </div>
            </Col>

            <div
              style={{maxWidth: '200px', minWidth: '200px'}}
              className="wrapper__right"
            >
              <button
                className="float-right search-button primary-btn"
                disabled={false}
                type="submit"
              >
                {t('risk-cosideration.search.searchButton')}
              </button>
            </div>
          </Row>
        </form>
      </FormProvider>
    </>
  );
};
export default FindingsFilter;
